module.exports = __webpack_public_path__ + "img/WBMLogo.cb0165b5.png";